import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { startRipristinaDefaults } from 'uniba-volto-persone/actions';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { Icon } from 'design-react-kit';


class RipristinaDefaultsToolbar extends Component {
    componentDidUpdate(prevProps) {
        const { toast } = this.props.toastify;
        const currentPath = this.currentPath;
        const prevResult = prevProps.ripristinaDefaultsReducer?.[currentPath];
        const currentResult = this.props.ripristinaDefaultsReducer?.[currentPath];

        if (currentResult && currentResult !== prevResult) {
            const resMsg = currentResult.msg?.toString() || 'Errore sconosciuto';
            if (currentResult.result === true) {
                toast.success(`Ripristino Defaults completato con successo: ${resMsg}`);
            } else {
                toast.error(`Errore nel Ripristino Defaults: ${resMsg}`);
            }
        }
    }

    hasPermissions() {
        const { actions } = this.props;
        return actions?.user?.some((ua) => ua?.id === 'toolbar-ripristina-defaults');
    }

    getCurrentPath() {
        const { breadcrumbs } = this.props;
        return breadcrumbs?.length > 0
            ? breadcrumbs[breadcrumbs.length - 1]?.url
            : '/';
    }

    handleClick = (e) => {
        e.preventDefault();
        const path = this.getCurrentPath();
        this.currentPath = path;
        this.props.startRipristinaDefaults(path);
    };

    render() {
        if (!this.hasPermissions()) return null;

        const { intl } = this.props;
        const toolbar_title = intl.formatMessage({ id: 'ripristina_defaults' });

        return (
            <Plug pluggable="main.toolbar.top" id="ripristina-defaults-toolbar">
                <Link
                    to="#"
                    onClick={this.handleClick}
                    aria-label={toolbar_title}
                    alt={toolbar_title}
                    title={toolbar_title}
                    tabIndex={0}
                    className="deleteBlocks"
                    id="toolbar-ripristina-defaults"
                >
                    <Icon icon="it-restore" color="secondary" size="md" title={toolbar_title} alt={toolbar_title} />
                </Link>
            </Plug>
        );
    }
}

const mapStateToProps = (state) => ({
    actions: state?.actions?.actions,
    breadcrumbs: state.breadcrumbs.items || [],
    ripristinaDefaultsReducer: state.ripristinaDefaultsReducer?.items || {}
});

const mapDispatchToProps = {
    startRipristinaDefaults,
};

export default injectLazyLibs(['toastify'])(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
        (injectIntl(
            RipristinaDefaultsToolbar
        ))
);
